import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-people-profile',
  templateUrl: './people-profile.component.html',
  styleUrls: ['./people-profile.component.css']
})
export class PeopleProfileComponent implements OnInit {

  peopleProfileInfo: any; 
  userInfo: any; 
 // isMemberFirmEnabled: boolean = false;
  //constructor(private auth: AuthService) { }

  ngOnInit() {
    const jsonString = localStorage.getItem('peopleProfile');
    this.peopleProfileInfo = JSON.parse(jsonString);


  }

 /* clearCacheAndLogout() {
    setTimeout(function() {
      this.auth.logout();
    }, 5000);
  }*/

}
